import { FC } from "react";

import { EditorialModuleImageProps } from "@/components/Editorial2Col/EditorialModuleImage";
import Image from "@/components/ui/Image/Image";
import useMediaQuery from "@/hooks/useMediaQuery";

const TiledImageVertical: FC<EditorialModuleImageProps> = ({ entry, slideIndex }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <div className={`col-span-1 grid grid-cols-1 ${slideIndex === 0 ? "pr-xs" : "pl-s md:pl-xxs"}`}>
      <Image
        src={isMobile ? entry.mobileImage?.url ?? entry.image.url : entry.image.url}
        width={267}
        height={542}
        className="w-full h-full aspect-2-1 rounded-lg"
        alt={entry.image.title}
      />
    </div>
  );
};
export default TiledImageVertical;
